import {
  Box,
  Container,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import times from "lodash/times";

export default function DetailViewLoading({ size = 4 }: { size?: number }) {
  return (
    <Container maxWidth="sm" sx={{ pt: 2 }}>
      {/* Header Skeleton */}
      <Box sx={{ mb: 2 }}>
        <Skeleton variant="text" width={100} height={16} sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width={180} height={28} />
      </Box>

      {/* Metrics Cards Skeleton */}
      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 1,
          }}
        >
          <Skeleton
            variant="rectangular"
            height={120}
            sx={{ borderRadius: 2 }}
          />
          <Skeleton
            variant="rectangular"
            height={120}
            sx={{ borderRadius: 2 }}
          />
        </Box>
      </Box>

      {/* List Section Skeleton */}
      <Box sx={{ mb: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={80} height={32} />
        </Box>
        <Box
          sx={{
            border: "1px solid #D3C9E7",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <List sx={{ p: 0 }}>
            {times(size).map((n) => (
              <ListItem
                key={`detailview-skeleton-${n}`}
                sx={{ px: 2, py: 1.5 }}
              >
                <ListItemAvatar sx={{ minWidth: 48 }}>
                  <Skeleton variant="rounded" width={36} height={36} />
                </ListItemAvatar>
                <ListItemText
                  primary={<Skeleton variant="text" width={120} height={20} />}
                  secondary={<Skeleton variant="text" width={80} height={16} />}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>
    </Container>
  );
}
